import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has been stable for `delayMs`.
 *
 * Prefer this over hand-rolled setTimeout refs when the debounced value feeds
 * a React Query key: the query itself becomes the single source of loading /
 * error state and no imperative timer bookkeeping is needed.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
